import { dataLayer } from '@doda/common/src/utils/googleTagManagerUtil';
import { AppThunk } from '@doda/common/src/redux/store';
import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';

/**
 * レコメンド求人が画面内に表示されたときの計測
 * @param recommendType レコメンド種別
 * @param recommendJobList 表示されたレコメンド求人リスト
 */
export function measureRecommendVisible(
  recommendType: string | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recommendJobList: any[] | null
) {
  const jobCount = recommendJobList?.length ?? 0;
  const linkTrackVars = 'eVar181,eVar182,eVar183,eVar184';

  if (jobCount === 0) {
    tl(`recommendVisible:ranking_${recommendType}`, {
      linkTrackVars,
      linkTrackEvents: 'None',
      eVar181: `${jobCount}`,
    });
    return;
  }

  if (recommendJobList) {
    tl(`recommendVisible:ranking_${recommendType}`, {
      linkTrackVars,
      linkTrackEvents: 'None',
      eVar181: `${jobCount}`,
      ...(recommendJobList.length > 0 && {
        eVar182: getItemNoStringInRange(recommendJobList, 0, 19),
      }),
    });
  }
}

/**
 * レコメンドカードがクリックされたときの計測
 * @param root0
 */
export function measureClickRecommendCard({
  recommendType,
  effectName,
}: {
  recommendType: string;
  effectName: string;
}): AppThunk<void> {
  return () => {
    const linkName = 'siteRecommendTracking';
    const eVar103 = `ranking_${recommendType}`;
    const eVar104 = `ranking_${effectName}`;
    tl(linkName, {
      eVar103,
      eVar104,
    });
    dataLayer({
      siteRecommendLogic: eVar103,
      siteRecommendTrackParam: eVar104,
      event: linkName,
    });
  };
}

/**
 * グラフ内の項目がクリックされた時の計測
 * @param root0
 */
export function measurejobtrendGraph({
  analyticsValue,
}: {
  analyticsValue: string;
}): AppThunk<void> {
  return () => {
    tl(`Jobtrend_graph_click_${analyticsValue}`, {});
  };
}

/**
 * すべての求人を見るリンクがクリックされた時の計測
 * @param root0
 */
export function measureJobSearchListLink({
  analyticsValue,
}: {
  analyticsValue: string;
}): AppThunk<void> {
  return () => {
    tl(`Jobtrend_recommendlist_click_${analyticsValue}`, {});
  };
}

/**
 * 指定された範囲の要素のitemNoをカンマで繋いだ文字列を返す
 * @param {Array<{ itemNo: string }>} itemNoを持つオブジェクトの配列
 * @param items
 * @param {number} startIndex 範囲の開始インデックス
 * @param {number} endIndex 範囲の終了インデックス
 * @returns {string} itemNoをカンマで繋いだ文字列
 */
export const getItemNoStringInRange = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: Pick<any, 'jid'>[],
  startIndex: number,
  endIndex: number
): string => {
  if (startIndex < 0 || startIndex > endIndex) {
    throw new Error('インデックスが無効です。');
  }

  // endIndex が範囲外の場合、最後のインデックスに設定
  const validEndIndex = endIndex + 1 >= items.length ? items.length : endIndex;

  return items
    .slice(startIndex, validEndIndex)
    .map((item) => item.jid)
    .join(',');
};
